import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import heroImage1 from "../images/header-Transfer-YourLife.jpg.jpeg";
import heroImage2 from "../images/header-FindYourGround.jpg.jpeg";
import heroImage3 from "../images/header-TurnConfusionIntoClearAction.jpg.jpeg";
import { useForm } from "./FormContext";

const Banner = () => {
  const { openForm } = useForm();
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };

  const slides = [
    {
      image: heroImage1,
      title: (
        <>
          Find Clarity. Build Confidence.
          <br /> Transform Your Life
        </>
      ),
      subtitle:
        "Personalized coaching to help you overcome confusion, gain direction and create a life that feels aligned and fulfilling.",
    },
    {
      image: heroImage2,
      title: (
        <>
          Feeling Stuck or Overwhelmed?
          <br /> Let’s Find Your Ground.
        </>
      ),
      subtitle:
        "Navigate uncertainty with structured support and build a life that feels aligned and stable.",
    },
    {
      image: heroImage3,
      title: "Turn Confusion Into Clear Action.",
      subtitle: "Move from overthinking to confident, meaningful decisions.",
    },
  ];

  return (
    <section className="hero">
      <div className="hero-inner">
        <Slider {...sliderSettings} className="hero-slider">
          {slides.map((slide, index) => (
            <div key={index} className="slide">
              <div
                className="hero_slide"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="container">
                  <p className="hero-subtitle-compact">
                    Life Coaching for Professionals Seeking Clarity, Confidence
                    and Direction
                  </p>
                  <h1>{slide.title}</h1>
                  <p className="hero-subtitle">{slide.subtitle}</p>

                  <button
                    type="button"
                    className="btn-new mt-3"
                    onClick={openForm}
                    style={{ border: "none", cursor: "pointer" }}
                  >
                    Book a Free Discovery Call
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Banner;
